import { render, staticRenderFns } from "./RedemptionRateRankingSection.vue?vue&type=template&id=2a2648e2&scoped=true&"
import script from "./RedemptionRateRankingSection.vue?vue&type=script&lang=js&"
export * from "./RedemptionRateRankingSection.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionRateRankingSection.vue?vue&type=style&index=0&id=2a2648e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2648e2",
  null
  
)

export default component.exports